<script>
    export default {
        props: [
            'route',
            'routeShippingNotes',
            'summaryShippingType',
            'shippingData',
            'brtCustomProductCode',
            'brtPudoProductCode'
        ],
        data() {
            return {
                shippingType: null,
                shippingName: null,
                shippingSurname: null,
                shippingEmail: null,
                shippingPhone: null,
                shippingAddress: null,
                shippingBrtPudoId: null,
                shippingBrtPudoName: null,
                shippingPostalCode: null,
                shippingCity: null,
                shippingProvince: null,
                shippingNotes: null,
                translatedShippingType: null,
            }
        },
        created: function() {

        },
        mounted: function() {
            this.translatedShippingType = this.summaryShippingType;
            this.shippingType = this.shippingData.shipping_type;
            this.shippingName = this.shippingData.shipping_name;
            this.shippingSurname = this.shippingData.shipping_surname;
            this.shippingEmail = this.shippingData.shipping_email;
            this.shippingPhone = this.shippingData.shipping_phone;
            this.shippingAddress = this.shippingData.shipping_address;
            this.shippingBrtPudoName = this.shippingData.shipping_brt_pudo_name;
            this.shippingBrtPudoId = this.shippingData.shipping_brt_pudo_id;
            this.shippingPostalCode = this.shippingData.shipping_postal_code;
            this.shippingCity = this.shippingData.shipping_city;
            this.shippingProvince = this.shippingData.shipping_province;
            this.shippingNotes = this.shippingData.shipping_notes;

            let _this = this;
            Event.$on("shippingBrtPudoUpdated", function(shippingData) {
                _this.shippingAddress = shippingData.shippingAddress;
                _this.shippingBrtPudoName = shippingData.shippingBrtPudoName;
                _this.shippingBrtPudoId = shippingData.shippingBrtPudoId;
                _this.shippingPostalCode = shippingData.shippingPostalCode;
            });

            $(function () {
                $('#shipping_type').change(function () {
                    _this.shippingAddress = '';
                    _this.shippingPostalCode = '';
                    _this.shippingBrtPudoName = '';
                    _this.shippingBrtPudoId = '';
                    _this.shippingCity = '';
                    _this.shippingProvince = '';
                    $('#shipping_city').empty().trigger('change');
                    $('#shipping_province').empty().trigger('change');
                });
            });
        },
        methods: {
            saveShipping() {
                this.shippingType = $('#shipping_type').val();
                this.shippingCity = $('#shipping_city').val();
                this.shippingProvince = $('#shipping_province').val();
                this.shippingAddress =  $('#shipping_address').val();
                this.shippingBrtPudoName = $('#shipping_brt_pudo_name').val();
                this.shippingBrtPudoId = $('#shipping_brt_pudo_id').val();
                this.shippingPostalCode = $('#shipping_postal_code').val();
                let data = {
                    shipping_type: this.shippingType ,
                    shipping_name: this.shippingName,
                    shipping_surname: this.shippingSurname,
                    shipping_email: this.shippingEmail,
                    shipping_phone: this.shippingPhone,
                    shipping_address: this.shippingAddress,
                    shipping_brt_pudo_name: this.shippingBrtPudoName,
                    shipping_brt_pudo_id: this.shippingBrtPudoId,
                    shipping_postal_code: this.shippingPostalCode,
                    shipping_city: this.shippingCity,
                    shipping_province: this.shippingProvince,
                    shipping_notes: this.shippingNotes
                };

                axios.post(this.route, data).then((res) => {
                    $('#shipping-data-modal').modal('hide');
                    this.translatedShippingType = $('#shipping_type option[value="' + this.shippingType + '"]').html();
                    switch (this.shippingType) {
                        case 'swisscare':
                            Event.$emit('shippingTypeUpdated', null, this.brtCustomProductCode);
                            Event.$emit('shippingTypeUpdated', null, this.brtPudoProductCode);
                            break;
                        case 'brt_custom':
                            Event.$emit('shippingTypeUpdated', this.brtCustomProductCode, this.brtPudoProductCode);
                            break;
                        case 'brt_pudo':
                            Event.$emit('shippingTypeUpdated', this.brtPudoProductCode, this.brtCustomProductCode);
                            break;
                    }

                    $('#shipping-data-modal').find('.help-block').remove();
                    $('#shipping-data-modal').find('.has-error').removeClass('has-error');
                }).catch((err) => {
                    $('#shipping-data-modal').find('.help-block').remove();
                    $('#shipping-data-modal').find('.has-error').removeClass('has-error');
                    if (err.response.status == 422) {
                        $(Object.keys(err.response.data.errors)).each(function () {
                            let fieldName = this;
                            if(err.response.data.errors[fieldName][0] != undefined) {
                                $('#' + fieldName).closest('.form-group').addClass('has-error');
                                $('#' + fieldName).closest('.form-group').append('<span class="help-block">' + err.response.data.errors[fieldName][0] + '</span>');
                            }
                        });
                    } else {
                        console.log(err);
                    }
                });
            },
            saveShippingNotes: function() {
                $('.order__summary .div-preloader').fadeIn();
                axios.post(this.routeShippingNotes, {shipping_notes: this.shippingNotes}).then((res) => {
                    $('.order__summary .div-preloader').fadeOut();
                }).catch((err) => {
                    console.log(err);
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/app/components/orders/orderShipping.vue